import { useEffect, useState } from 'react';
import { BaseModal } from '@/components/shared';
import { useCandidatoMutations } from '../../../hooks/data';
import type { Candidato } from '../../../models';

interface EditarCandidatoModalProps {
  candidato: Candidato | null;
  onClose: () => void;
}

/** Corrige nome/e-mail cadastrados errado — não mexe em status/respostas/link (ver
 * candidatoService.atualizar). */
export default function EditarCandidatoModal({ candidato, onClose }: EditarCandidatoModalProps) {
  const { atualizarCandidato } = useCandidatoMutations();

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (candidato) {
      setNome(candidato.nome);
      setEmail(candidato.email);
    }
  }, [candidato]);

  const podeSubmeter = Boolean(nome.trim() && email.trim());
  const salvando = atualizarCandidato.isPending;

  const handleClose = () => {
    if (salvando) return;
    onClose();
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!candidato || !podeSubmeter) return;

    await atualizarCandidato.mutateAsync({ id: candidato.id, nome: nome.trim(), email: email.trim() });
    onClose();
  };

  return (
    <BaseModal isOpen={candidato != null} onClose={handleClose} title="Editar Candidato" maxWidth="max-w-md" fullHeight={false}>
      <form onSubmit={handleSubmit} className="space-y-4 py-2">
        <div>
          <label className="block text-sm font-medium text-gray-700">Nome *</label>
          <input
            type="text"
            className="input-primary mt-1 w-full"
            value={nome}
            onChange={(event) => setNome(event.target.value)}
            disabled={salvando}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">E-mail *</label>
          <input
            type="email"
            className="input-primary mt-1 w-full"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            disabled={salvando}
          />
        </div>
        <div className="flex justify-end gap-3">
          <button type="button" className="btn-secondary" onClick={handleClose} disabled={salvando}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" disabled={!podeSubmeter || salvando}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </BaseModal>
  );
}
